/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_StreetInputs */

const cs_form_street = /** @type {(inputs: Form_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulice`)
};

const en_form_street = /** @type {(inputs: Form_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Form_StreetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_street = /** @type {((inputs?: Form_StreetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_StreetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_street(inputs)
	return cs_form_street(inputs)
});